import { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";
import { api, fileUrl } from "@/lib/api";
import { setActiveCurrency } from "@/lib/currency";

const SettingsContext = createContext(null);

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/storefront/settings");
      setSettings(data);
    } catch (e) {
      if (process.env.NODE_ENV !== "production") {
        // eslint-disable-next-line no-console
        console.error("settings load failed", e);
      }
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  useEffect(() => {
    if (!settings) return;
    setActiveCurrency(settings.currency_code || "USD");
    if (settings.legal_business_name) {
      document.title = `${settings.legal_business_name} · ${settings.tagline || "quiet luxury"}`;
    }
    if (settings.favicon_path) {
      let link = document.querySelector("link[rel='icon']");
      if (!link) { link = document.createElement("link"); link.rel = "icon"; document.head.appendChild(link); }
      link.href = fileUrl(settings.favicon_path);
    }
  }, [settings]);

  const value = useMemo(() => ({ settings, refresh, setSettings }), [settings, refresh]);

  return (
    <SettingsContext.Provider value={value}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);
